const EmptyContainers = () => {
    return (
      <div className="empty-container"></div>
    );
  };
  
  export default EmptyContainers;
  